import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAppContext } from '../context/AppContext';

const CITIES = ['Казань', 'Зеленодольск', 'Волжск'];
const DISTRICTS = ['Мирный', 'Город', 'Зеленый дол'];

const buildAddress = (a) => [
  a.street,
  a.house     ? `д. ${a.house}`      : null,
  a.entrance  ? `пд. ${a.entrance}`  : null,
  a.floor     ? `эт. ${a.floor}`     : null,
  a.apartment ? `кв. ${a.apartment}` : null,
].filter(Boolean).join(', ');

const todayStr = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
const tomorrowStr = () => { const d = new Date(); d.setDate(d.getDate()+1); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
const fmtDate = (s) => { const [,m,d] = s.split('-'); return `${d}.${m}`; };

export default function CartScreen() {
  const navigate = useNavigate();
  const { cart, cartTotal, updateCartQuantity, removeFromCart, clearCart, user, minOrderQty: ctxMinQty } = useAppContext();
  const [addrFields, setAddrFields] = useState({ street: '', house: '', entrance: '', floor: '', apartment: '' });
  const [phone, setPhone] = useState(user?.phone || '');
  const [comment, setComment] = useState('');
  const [exchangeQty, setExchangeQty] = useState('');
  const [deliveryDay, setDeliveryDay] = useState('today');
  const [city, setCity] = useState(null);
  const [district, setDistrict] = useState(null);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [addrPickerVisible, setAddrPickerVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [todayEnabled, setTodayEnabled] = useState(true);
  const [minOrderQty, setMinOrderQty] = useState(ctxMinQty);

  useEffect(() => {
    const raw = localStorage.getItem(`saved_addresses_${user?.id}`);
    if (raw) { try { setSavedAddresses(JSON.parse(raw)); } catch {} }
  }, [user?.id]);

  useEffect(() => {
    api.settings.get().then(s => {
      if (s?.today_delivery_enabled === false) { setTodayEnabled(false); setDeliveryDay('tomorrow'); }
      if (s?.min_order_quantity) setMinOrderQty(s.min_order_quantity);
    }).catch(() => {});
  }, []);

  const totalItems = cart.reduce((sum, i) => sum + i.quantity, 0);
  const exchangeCount = Number(exchangeQty || 0);
  const discountTotal = exchangeCount * 280;
  const finalTotal = Math.max(0, cartTotal - discountTotal);

  const handlePhoneChange = (v) => {
    let c = v.replace(/[^\d+]/g, '');
    if (c.startsWith('8')) c = '+7' + c.slice(1);
    if (c.startsWith('7') && !c.startsWith('+7')) c = '+' + c;
    if (c.length > 12) return;
    setPhone(c);
    if (errors.phone) setErrors(p => ({ ...p, phone: null }));
  };

  const validate = () => {
    const e = {};
    if (!user?.isAdmin && totalItems < minOrderQty) e.minQty = `Минимальный заказ — ${minOrderQty} шт. (сейчас ${totalItems})`;
    if (!addrFields.street.trim()) e.address = 'Введите улицу';
    else if (!addrFields.house.trim()) e.address = 'Введите номер дома';
    if (!phone.trim()) e.phone = 'Введите телефон';
    else if (!/^\+7\d{10}$/.test(phone)) e.phone = 'Формат: +79991234567';
    if (!city) e.city = 'Выберите город доставки';
    if (city === 'Зеленодольск' && !district) e.district = 'Выберите район';
    if (exchangeQty === '') e.exchangeQty = 'Укажите бутыли на обмен (0 если нет)';
    else if (Number(exchangeQty) > totalItems) e.exchangeQty = 'Не может быть больше количества';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      let rem = exchangeCount;
      const addr = buildAddress(addrFields);
      const date = deliveryDay === 'today' ? todayStr() : tomorrowStr();
      const items = cart.map(item => {
        const ex = Math.min(item.quantity, rem); rem -= ex;
        return { brand: item.product.brand, volume: item.product.volume, price: item.product.price, address: addr, phone, quantity: item.quantity, exchange_count: ex, total_price: Math.max(0, item.product.price * item.quantity - ex * 280), delivery_day: date, city, district: district || null, comment: comment.trim() };
      });
      await api.orders.createBatch(items);
      clearCart();
      setSuccess(true);
    } catch { alert('Нет соединения с сервером'); }
    finally { setLoading(false); }
  };

  if (success) return (
    <div style={{ padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', gap: 16, textAlign: 'center' }}>
      <div style={{ fontSize: 64 }}>🎉</div>
      <h2 style={{ color: 'var(--primary)', fontSize: 22 }}>Заказ оформлен!</h2>
      <p style={{ color: 'var(--text-light)' }}>Ожидайте доставку</p>
      <button onClick={() => navigate('/')} style={btnStyle}>На главную</button>
    </div>
  );

  if (cart.length === 0) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', gap: 12, padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 48 }}>🛒</div>
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>Корзина пуста</h2>
      <p style={{ color: 'var(--text-light)', fontSize: 15 }}>Добавьте товары из каталога, чтобы оформить заказ</p>
      <button onClick={() => navigate('/')} style={btnStyle}>Перейти в каталог</button>
    </div>
  );

  return (
    <div style={{ padding: '0 16px 100px' }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--primary)', marginTop: 16, marginBottom: 16 }}>Корзина</h1>

      {/* Товары */}
      {cart.map(item => (
        <div key={item.product.id} style={cardStyle}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 32, marginRight: 12 }}>{item.product.emoji || '💧'}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, color: 'var(--primary)' }}>{item.product.brand}</div>
              <div style={{ fontSize: 13, color: 'var(--text-light)' }}>{item.product.volume} · {item.product.price} ₽/шт</div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button onClick={() => updateCartQuantity(item.product.id, item.quantity - 1)} style={qtyBtnStyle}>−</button>
              <input
                type="number" min={1} max={99}
                value={item.quantity}
                onChange={e => { const n = parseInt(e.target.value); if (!isNaN(n)) updateCartQuantity(item.product.id, n); }}
                style={{ width: 48, height: 34, textAlign: 'center', fontSize: 16, fontWeight: 700, color: 'var(--text)', background: 'var(--input-bg)', border: '1.5px solid var(--border)', borderRadius: 10, outline: 'none' }}
              />
              <button onClick={() => updateCartQuantity(item.product.id, item.quantity + 1)} style={qtyBtnStyle}>+</button>
            </div>
            <button onClick={() => removeFromCart(item.product.id)} style={{ background: 'none', color: '#FF3B30', fontSize: 13, fontWeight: 700 }}>Удалить</button>
          </div>
          <div style={{ marginTop: 8, fontWeight: 700, fontSize: 15 }}>Итого: {item.product.price * item.quantity} ₽</div>
        </div>
      ))}

      {/* Сумма */}
      <div style={{ ...cardStyle, textAlign: 'center' }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--primary)' }}>Сумма заказа: {finalTotal} ₽</div>
        <div style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 4 }}>Скидка по обмену: {discountTotal} ₽</div>
      </div>

      <form onSubmit={handleCheckout}>
        {/* Обмен */}
        <label style={labelStyle}>Бутыли на обмен</label>
        <input type="number" min={0} placeholder="0" value={exchangeQty}
          onChange={e => { const v = e.target.value; if (Number(v) <= totalItems) { setExchangeQty(v); setErrors(p => ({ ...p, exchangeQty: null })); } }}
          style={{ ...inputStyle, borderColor: errors.exchangeQty ? '#FF3B30' : 'var(--border)' }} />
        {errors.exchangeQty && <p style={errorStyle}>⚠ {errors.exchangeQty}</p>}

        {/* Город */}
        <label style={labelStyle}>Город доставки</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
          {CITIES.map(c => (
            <button key={c} type="button" onClick={() => { setCity(c); setDistrict(null); setErrors(p => ({ ...p, city: null })); }}
              style={{ flex: 1, padding: '10px 4px', borderRadius: 10, border: '1.5px solid', borderColor: city === c ? 'var(--primary)' : 'var(--border)', background: city === c ? 'var(--primary)' : 'var(--card)', color: city === c ? '#fff' : 'var(--text)', fontWeight: 600, fontSize: 13 }}>
              {c}
            </button>
          ))}
        </div>
        {errors.city && <p style={errorStyle}>⚠ {errors.city}</p>}

        {/* Район */}
        {city === 'Зеленодольск' && (
          <>
            <label style={labelStyle}>Район</label>
            <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
              {DISTRICTS.map(d => (
                <button key={d} type="button" onClick={() => { setDistrict(d); setErrors(p => ({ ...p, district: null })); }}
                  style={{ flex: 1, padding: '10px 4px', borderRadius: 10, border: '1.5px solid', borderColor: district === d ? 'var(--primary)' : 'var(--border)', background: district === d ? 'var(--primary)' : 'var(--card)', color: district === d ? '#fff' : 'var(--text)', fontWeight: 600, fontSize: 13 }}>
                  {d}
                </button>
              ))}
            </div>
            {errors.district && <p style={errorStyle}>⚠ {errors.district}</p>}
          </>
        )}

        {/* Адрес */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
          <label style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)' }}>Адрес доставки</label>
          {savedAddresses.length > 0 && (
            <button type="button" onClick={() => setAddrPickerVisible(true)}
              style={{ background: 'rgba(26,109,181,0.1)', border: '1px solid var(--primary)', borderRadius: 8, padding: '4px 10px', color: 'var(--primary)', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              Мои адреса
            </button>
          )}
        </div>
        <label style={addrLabelStyle}>Улица <span style={{ color: '#FF3B30' }}>*</span></label>
        <input placeholder="ул. Ленина" value={addrFields.street} onChange={e => { setAddrFields(p => ({ ...p, street: e.target.value })); setErrors(p => ({ ...p, address: null })); }}
          style={{ ...inputStyle, borderColor: errors.address ? '#FF3B30' : 'var(--border)' }} />
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 1 }}>
            <label style={addrLabelStyle}>Дом <span style={{ color: '#FF3B30' }}>*</span></label>
            <input placeholder="1" value={addrFields.house} onChange={e => { setAddrFields(p => ({ ...p, house: e.target.value })); setErrors(p => ({ ...p, address: null })); }}
              style={{ ...inputStyle, borderColor: errors.address ? '#FF3B30' : 'var(--border)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={addrLabelStyle}>Подъезд</label>
            <input placeholder="2" value={addrFields.entrance} onChange={e => setAddrFields(p => ({ ...p, entrance: e.target.value }))} style={inputStyle} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 1 }}>
            <label style={addrLabelStyle}>Этаж</label>
            <input placeholder="5" value={addrFields.floor} onChange={e => setAddrFields(p => ({ ...p, floor: e.target.value }))} style={inputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={addrLabelStyle}>Квартира</label>
            <input placeholder="10" value={addrFields.apartment} onChange={e => setAddrFields(p => ({ ...p, apartment: e.target.value }))} style={inputStyle} />
          </div>
        </div>
        {errors.address && <p style={errorStyle}>⚠ {errors.address}</p>}

        {/* Телефон */}
        <label style={labelStyle}>Телефон <span style={{ fontSize: 13, color: 'var(--text-light)', fontWeight: 400 }}>{phone.length}/12</span></label>
        <input type="tel" placeholder="+79991234567" value={phone} onChange={e => handlePhoneChange(e.target.value)}
          style={{ ...inputStyle, borderColor: errors.phone ? '#FF3B30' : 'var(--border)' }} />
        {errors.phone && <p style={errorStyle}>⚠ {errors.phone}</p>}

        {/* День доставки */}
        <label style={labelStyle}>День доставки</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
          {todayEnabled && (
            <button type="button" onClick={() => { setDeliveryDay('today'); setErrors(p => ({ ...p, deliveryDay: null })); }}
              style={{ flex: 1, padding: '10px', borderRadius: 10, border: '1.5px solid', borderColor: deliveryDay === 'today' ? 'var(--primary)' : 'var(--border)', background: deliveryDay === 'today' ? 'var(--primary)' : 'var(--card)', color: deliveryDay === 'today' ? '#fff' : 'var(--text)', fontWeight: 600 }}>
              Сегодня<br /><span style={{ fontSize: 12 }}>{fmtDate(todayStr())}</span>
            </button>
          )}
          <button type="button" onClick={() => { setDeliveryDay('tomorrow'); setErrors(p => ({ ...p, deliveryDay: null })); }}
            style={{ flex: 1, padding: '10px', borderRadius: 10, border: '1.5px solid', borderColor: deliveryDay === 'tomorrow' ? 'var(--primary)' : 'var(--border)', background: deliveryDay === 'tomorrow' ? 'var(--primary)' : 'var(--card)', color: deliveryDay === 'tomorrow' ? '#fff' : 'var(--text)', fontWeight: 600 }}>
            Завтра<br /><span style={{ fontSize: 12 }}>{fmtDate(tomorrowStr())}</span>
          </button>
        </div>

        {/* Комментарий */}
        <label style={labelStyle}>Комментарий <span style={{ fontSize: 13, color: 'var(--text-light)', fontWeight: 400 }}>{comment.length}/200</span></label>
        <textarea placeholder="Код домофона, этаж, пожелания..." value={comment} onChange={e => { if (e.target.value.length <= 200) setComment(e.target.value); }}
          style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }} />

        {errors.minQty && <p style={{ ...errorStyle, marginBottom: 8 }}>⚠ {errors.minQty}</p>}

        <button type="submit" disabled={loading} style={{ ...btnStyle, opacity: loading ? 0.6 : 1, marginTop: 16 }}>
          {loading ? 'Оформление...' : `Оформить заказ — ${finalTotal} ₽`}
        </button>
      </form>

      {addrPickerVisible && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 1000 }} onClick={() => setAddrPickerVisible(false)}>
          <div style={{ background: 'var(--card)', borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: 24, width: '100%', maxHeight: '60vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>Выберите адрес</h3>
            {savedAddresses.map(a => (
              <div key={a.id} style={{ background: 'var(--input-bg)', borderRadius: 12, padding: 16, marginBottom: 8, cursor: 'pointer' }}
                onClick={() => { setAddrFields({ street: a.street || '', house: a.house || '', entrance: a.entrance || '', floor: a.floor || '', apartment: a.apartment || '' }); setCity(a.city || null); setDistrict(a.district || null); setErrors(p => ({ ...p, address: null, city: null, district: null })); setAddrPickerVisible(false); }}>
                <div style={{ fontWeight: 700, marginBottom: 2 }}>{a.label}</div>
                <div style={{ fontSize: 14 }}>{buildAddress(a)}</div>
                <div style={{ fontSize: 13, color: 'var(--text-light)' }}>{a.city}{a.district ? ` · ${a.district}` : ''}</div>
              </div>
            ))}
            <button onClick={() => setAddrPickerVisible(false)} style={{ width: '100%', padding: 12, background: 'none', color: 'var(--text-light)', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8 }}>Отмена</button>
          </div>
        </div>
      )}
    </div>
  );
}

const cardStyle = { background: 'var(--card)', borderRadius: 14, padding: 16, marginBottom: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const inputStyle = { display: 'block', width: '100%', background: 'var(--input-bg)', borderRadius: 12, padding: '12px 16px', fontSize: 15, color: 'var(--text)', border: '1.5px solid var(--border)', outline: 'none', marginBottom: 4 };
const labelStyle = { display: 'block', fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 8, marginTop: 12 };
const addrLabelStyle = { display: 'block', fontSize: 14, fontWeight: 600, color: 'var(--text)', marginTop: 8, marginBottom: 6 };
const errorStyle = { fontSize: 13, color: '#FF3B30', marginBottom: 8 };
const btnStyle = { display: 'block', width: '100%', padding: 14, borderRadius: 14, background: 'var(--primary)', color: '#fff', fontSize: 16, fontWeight: 700 };
const qtyBtnStyle = { width: 34, height: 34, borderRadius: 10, background: 'var(--primary)', color: '#fff', fontSize: 20, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' };
